import React from "react";
import {
  DetailsList,
  DetailsListHeader,
} from "../../../../shared/styles/Card.styles";
import { ITimingListProps } from "./TimingList.types";
import { EPhaseNames } from "../../../../shared/enums/phases.enums";
import DEFAULT_TIMING_STACK from "./Specializations/DefaultTiming.component";
import SCHEDULING_TIMING_STACK from "./Specializations/SchedulingTiming.component";
import CONSTRUCTION_TIMING_STACK from "./Specializations/ConstructionTiming.component";

const TIMING_LIST: React.FC<ITimingListProps> = (props: ITimingListProps) => {
  const { timing, phase } = props;

  let PickedSpecialization: React.FC<ITimingListProps>;
  switch (phase) {
    case EPhaseNames.SCHEDULING:
      PickedSpecialization = SCHEDULING_TIMING_STACK;
      break;

    case EPhaseNames.CONSTRUCTION:
      PickedSpecialization = CONSTRUCTION_TIMING_STACK;
      break;

    default:
      PickedSpecialization = DEFAULT_TIMING_STACK;
      break;
  }

  return (
    <DetailsList className="details-list">
      <DetailsListHeader
        className="details-list-header"
        direction="horizontal"
        data-testid="timing-details-header"
      >
        <h4>Timing</h4>
      </DetailsListHeader>
      <PickedSpecialization timing={timing} phase={phase} />
    </DetailsList>
  );
};
export default TIMING_LIST;
